import * as types from '../actions/actionTypes'

export default function raceListReducer(state = [], action) {
  switch (action.type) {
    case types.race.GET_RACES_SUCCESS:
      return { ...state, raceList: action.raceList }

    case types.race.GET_RACE1_SUCCESS:
      return { ...state, race: action.race }

    default:
      return state;
  }
}